import React from 'react';

export interface DetailField {
  label: string;
  value?: string | null;
  render?: React.ReactNode;
}

interface DetailFieldsCardProps {
  title: string;
  fields: DetailField[];
}

const DetailFieldsCard = ({ title, fields }: DetailFieldsCardProps) => {
  if (fields.length === 0) return null;

  return (
    <div className="border border-gray-200 rounded-lg p-6 space-y-5">
      <h3 className="text-gray-900">{title}</h3>
      {fields.map((field, index) => (
        <div key={field.label + index}>
          <p className="text-xs text-gray-500 mb-2">{field.label}</p>
          {field.render ?? (
            <p className="text-gray-900">{field.value || '-'}</p>
          )}
        </div>
      ))}
    </div>
  );
};

export default DetailFieldsCard;
